export default {
  TITLE: 'Amazon International Entity Registration Information',
  CONTENT: `
    <div>
      <h3>Amazon USA</h3>
      <table cellspacing="0" cellpadding="0">
        <tr>
          <td>Entity Name</td>
          <td>Amazon Export Sales LLC</td>
        </tr>
        <tr>
          <td>Country of Registration</td>
          <td>United States</td>
        </tr>
        <tr>
          <td>Registration Number</td>
          <td>3971236</td>
        </tr>
        <tr>
          <td>Registered Address</td>
          <td>251 Little Falls Drive, Wilmington, Delaware 19808, USA</td>
        </tr>
      </table>
      <h3>Amazon UK/Germany</h3>
      <table cellspacing="0" cellpadding="0">
        <tr>
          <td>Entity Name</td>
          <td>Amazon EU S.à r.l.</td>
        </tr>
        <tr>
          <td>Country of Registration</td>
          <td>Luxembourg</td>
        </tr>
        <tr>
          <td>Registration Number</td>
          <td>B101818</td>
        </tr>
        <tr>
          <td>Registered Address</td>
          <td>38 Avenue John F. Kennedy, L-1855 Luxembourg</td>
        </tr>
      </table>
      <h3>Amazon Japan</h3>
      <table cellspacing="0" cellpadding="0">
        <tr>
          <td>Entity Name</td>
          <td>Amazon Japan Godo Kaisha</td>
        </tr>
        <tr>
          <td>Country of Registration</td>
          <td>Japan</td>
        </tr>
        <tr>
          <td>Registration Number</td>
          <td>3040001028447</td>
        </tr>
        <tr>
          <td>Registered Address</td>
          <td>1-8-1 Shimo-Meguro, Meguro-ku, Tokyo, Japan</td>
        </tr>
      </table>
    </div>
  `
};
